import React from 'react';
import {IconButton, Stack, Typography} from '@mui/material';
import {ChevronLeft} from 'lucide-react';
import {useNavigate} from 'react-router-dom';
import PropTypes from 'prop-types';

export function NavHeader({children, title}) {
  const navigate = useNavigate();

  return (
    <Stack
      direction="row"
      width="100%"
      gap={1}
      py={1}
      px={2}
      height="72px"
      alignItems="center"
      justifyContent="space-between"
      zIndex={1}
      bgcolor="white"
      sx={{
        borderBottom: '1px solid #DCE2E0',
      }}
    >
      <Stack direction="row" alignItems="center" gap={1} whiteSpace="nowrap">
        <IconButton size="small" onClick={() => navigate(-1)}>
          <ChevronLeft size={18} />
        </IconButton>
        <Typography
          sx={{
            color: '#162523',
            fontWeight: 'bold',
            fontSize: 18,
            whiteSpace: 'nowrap',
          }}
        >
          {title}
        </Typography>
      </Stack>
      {children}
    </Stack>
  );
}

NavHeader.propTypes = {
  title: PropTypes.any,
  children: PropTypes.any,
};
